import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

export default function NotFound() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center bg-[#dce2d7] text-[#1f241d] px-4 py-20">
      <Helmet>
        <title>404 - Siden blev ikke fundet - PR Entreprise & Anlæg ApS</title>
        <meta name="description" content="Siden du leder efter på PR Entreprise & Anlæg ApS blev ikke fundet. Brug linket til at navigere tilbage til forsiden." />
      </Helmet>
      
      <div className="max-w-xl text-center space-y-6 bg-white p-10 rounded-none border border-[#cbd3c5] shadow-lg">
        <div className="w-20 h-20 rounded-none bg-[#141f14] text-[#9ecc49] flex items-center justify-center mx-auto text-3xl font-extrabold font-heading border border-[#233323]">
          404
        </div>

        <h1 className="font-heading text-xl sm:text-3xl font-bold text-[#1f241d]">
          Siden blev desværre ikke fundet
        </h1>

        <p className="text-[#4e564a] text-base leading-relaxed">
          Siden du leder efter eksisterer enten ikke, er blevet flyttet eller er midlertidigt utilgængelig.
        </p>

        <div className="pt-4 flex flex-wrap justify-center gap-4">
          <Link
            to="/"
            className="bg-[#3d5229] hover:bg-[#2e3f1e] text-white px-6 py-3 rounded-none font-heading font-semibold text-sm transition-colors"
          >
            &larr; Gå til forside
          </Link>
          <Link
            to="/ydelser"
            className="bg-[#dce2d7] hover:bg-[#cbd3c5] text-[#1f241d] border border-[#cbd3c5] px-6 py-3 rounded-none font-heading font-semibold text-sm transition-colors"
          >
            Se vores ydelser
          </Link>
          <Link
            to="/kontakt"
            className="bg-[#9ecc49] hover:bg-[#8ebb3c] text-[#1f241d] px-6 py-3 rounded-none font-heading font-bold uppercase text-xs tracking-wider transition-colors shadow"
          >
            Kontakt os
          </Link>
        </div>
      </div>
    </div>
  );
}
